import React, { ReactNode } from "react";
import { css, Theme, useTheme } from "@emotion/react";

import TruncateWithTippy from "core/Components/TruncateWithTippy";
import LinkTo from "core/Components/LinkTo";
import { useAppState } from "core/contexts/AppContext";

type Props = {
    children: ReactNode,
    to: string,
    tippyContent?: string,
};

const CardItemTitle: React.FC<Props> = ({ children, to, tippyContent = '' }) => {
    const theme: Theme = useTheme();
    const [, setAppState] = useAppState();

    const closeCartPopup = () => {
        setAppState({
            isOpenCartPopup: false
        });
    };

    const style = css`
        margin-left: 10px;
        width: 150px;
        height: 67px;
        line-height: 18px;
        color: ${theme.colours.shipGray};

        ${theme.breakpoints.only("xl")} {
            width: 135px;
        }

        ${theme.breakpoints.between("sm", "lg")} {
            width: 122px;
        }

        ${theme.breakpoints.down("xs")} {
            margin-left: 7px;
            width: 111px;
        }
    `;

    return (
        <LinkTo to={to} css={style} onClick={closeCartPopup}>
            <TruncateWithTippy text={tippyContent} lines={4}>
                <div>{children}</div>
            </TruncateWithTippy>
        </LinkTo>
    );
};

export default CardItemTitle;